<template>
  <div id="app" class="w-0">
    <!-- 可以被缓存的视图组件 -->
    <keep-alive>
      <router-view
        v-if="$route.meta.keepAlive"
        class="main"
        :key="key0"
      ></router-view>
    </keep-alive>
    <router-view
      v-if="!$route.meta.keepAlive"
      class="main"
      :key="key0"
    ></router-view>
    <go-top src="/static/images/top.png"></go-top>
  </div>
</template>
<script>
import GoTop from "@inotom/vue-go-top";
import {loginOut} from "./api";
import Cookies from "js-cookie";
export default {

  data() {
    return {
      gap_time: 0,
      beforeUnload_time: 0,
    };
  },
  methods: {
    // 关闭窗口之前执行
    beforeunloadHandler() {
      this.beforeUnload_time = new Date().getTime();
    },
    unloadHandler() {
      this.gap_time = new Date().getTime() - this.beforeUnload_time;
      //判断是窗口关闭还是刷新 毫秒数判断 网上大部分写的是5
      if (this.gap_time <= 10) {
        Cookies.remove("accessToken");
        Cookies.remove("nickName");
        Cookies.remove("Img");
        this.$store.commit("SET_TOKEN", undefined);
        this.$store.commit("SET_NICKNAME", undefined);
        this.$store.commit("SET_IMG", undefined);
        loginOut();
        // logout() // 退出登录接口 这里应当换为个人的登出方法
      } else {
      }
    },
  },
  destroyed() {
    // 移除监听
    window.removeEventListener("beforeunload", () => this.beforeunloadHandler());
    window.removeEventListener("unload", () => this.unloadHandler());
  },
  mounted() {
    // 监听浏览器关闭
    window.addEventListener("beforeunload", () => this.beforeunloadHandler());
    window.addEventListener("unload", () => this.unloadHandler());
  },

  components: {
    GoTop,
  },
  name: "app",
  created() {
    console.log(process.env);
  },
  computed: {
    key0() {
      return new Date().getTime();
    },
  },
};
</script>
<style lang="scss" rel="stylesheet/scss">
@import "assets/style/theme.scss";
@import "assets/style/index.scss";

#app {
  height: 100%;
  background-color: $main-col;
}

.main {
  background: #d7cfbe;
  display: flex;
  flex-direction: column;
  .content {
    min-height: calc(100vh - 180px);
    padding: 20px 0;
  }
}

.flex {
  display: flex;
}
.flex-col {
  display: flex;
  flex-direction: column;
}

.flex-1 {
  flex: 1;
}

.flex-col {
  flex-direction: column;
}
.justify-start {
  justify-content: flex-start;
}
.justify-center {
  justify-content: center;
}
.justify-end {
  justify-content: flex-end;
}
.justify-between {
  justify-content: space-between;
}

.items-center {
  align-items: center;
}

.items-start {
  align-items: flex-start;
}

.items-end {
  align-items: flex-end;
}

.content-center {
  align-content: center;
}

.w-full {
  width: 100%;
}

.h-full {
  height: 100%;
}

.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}

.title-color {
  color: #626262;
}
.gray-box {
  background-color: #efe8dd;
}
.ellipsis {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.sub-title .ellipsis-content {
  color: #858585 !important;
}
.primary-title .ellipsis-content {
  color: #626262 !important;
  font-size: 18px !important;
}
</style>



// WEBPACK FOOTER //
// App.vue?3792c1a9